import Company from '@/modules/companies/models/Company'
import { getCompanies } from '@/modules/companies/services/companyService'
import { useUserStore } from '@/store'
import { storeToRefs } from 'pinia'
import { ref, onMounted } from 'vue'

type CompanyDict = Record<string, Company>

export default async function useCompanies(search: string = '') {
  const { user } = storeToRefs(useUserStore())
  const companiesIds = user.value?.companies
  const companies = ref<Company[]>([])
  if (
    ['admin', 'RRHH'].includes(user.value?.roles.name ?? '') ||
    user?.value?.isRRHH
  ) {
    const allCompanies = await getCompanies(search)
    let companiesDict: CompanyDict = {}

    allCompanies.data.forEach((c) => (companiesDict[c.id] = { ...c }))

    companiesIds?.forEach((companyId: string) => {
      if (companiesDict[companyId])
        companies.value?.push(companiesDict[companyId])
    })
  }

  if (user.value?.roles.name === 'superadmin') {
    const allCompanies = await getCompanies(search)

    companies.value = allCompanies.data
  }

  return { companies }
}
